<h1 class="mb-3" mat-dialog-title>Generisanje poruka upozorenja</h1>
<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="dropdowns-div">
    <div class="type">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label class="label-mat">Tip poruke</mat-label>
        <mat-select formControlName="type">
          <mat-option *ngFor="let type of type$ | async" [value]="type">{{ type.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="text-area">
      <mat-form-field class="textarea" appearance="outline">
        <mat-label>Info poruka</mat-label>
        <textarea
          matInput
          formControlName="infoMessage"
          cdkTextareaAutosize
          cdkAutosizeMinRows="9"
          cdkAutosizeMaxRows="9"
        ></textarea>
      </mat-form-field>
    </div>
    <div class="text-area">
      <mat-form-field class="textarea" appearance="outline">
        <mat-label>Audio poruka</mat-label>
        <textarea
          matInput
          formControlName="audioMessage"
          cdkTextareaAutosize
          cdkAutosizeMinRows="9"
          cdkAutosizeMaxRows="9"
        ></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="submit-div">
    <button mat-flat-button mat-dialog-close>Odustani</button>
    <button [disabled]="!form.valid" mat-flat-button color="primary" type="submit">Generiši poruku upozorenja</button>
  </div>
</form>
